import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { Button, Menu, MenuItem, Icon, ListItemText, ListItemIcon, CircularProgress } from '@emburse/embark-core';
import { styled } from '@mui/material/styles';
import { ExpandMoreIcon } from '@emburse/embark-icons';
function MenuButton({ color, disabled, size, fullWidth, variant, children, menuItems, loading, onMenuSelect }) {
    const [anchor, setAnchor] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const buttonRef = useRef(null);
    const openMenu = (event) => {
        setAnchor(event.currentTarget);
        setMenuOpen(true);
    };
    const closeMenu = () => {
        setMenuOpen(false);
        setAnchor(null);
    };
    const onMenuSelectHandler = (item) => {
        setMenuOpen(false);
        onMenuSelect(item);
    };
    const StyledMenu = styled((props) => (_jsx(Menu, { anchorHorizontalPosition: "center", anchorVerticalPosition: "bottom", ...props })))(() => ({
        '& .MuiPaper-root': {
            minWidth: 180
        }
    }));
    return (_jsxs(_Fragment, { children: [_jsx(Button, { ref: buttonRef, color: color, disabled: disabled, size: size, fullWidth: fullWidth, variant: variant, endIcon: _jsx(Icon, { iconUrl: !loading ? (ExpandMoreIcon) : (_jsx(CircularProgress, { size: "1rem", color: "inherit", style: { marginLeft: '5px' } })), style: { marginTop: '-3px' } }), onClick: openMenu, children: children }), _jsx(StyledMenu, { anchorEl: anchor, open: menuOpen, onClose: closeMenu, children: menuItems.map((item, index) => (_jsxs(MenuItem, { value: item.value, onClick: () => {
                        onMenuSelectHandler(item);
                    }, children: [item.icon ? (_jsx(ListItemIcon, { children: _jsx(Icon, { iconUrl: item.icon }) })) : null, _jsx(ListItemText, { children: item.label })] }, item.id || index))) })] }));
}
MenuButton.defaultProps = {
    menuItems: []
};
export default MenuButton;
